import React, { PropsWithChildren } from "react";
import { TabsProvider } from "./useTabs";

const Tabs = (p: PropsWithChildren<{}>) => {
  return <TabsProvider>{p.children}</TabsProvider>;
};

export default Tabs;
